exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select[name=\"city\"] {\r\n    padding: 0.5rem 1.1rem 0.6rem !important;\r\n  }\r\n  .select-day{\r\n    width: 6.5rem;\r\n    float: left;\r\n    margin-right: 1rem;\r\n  }\r\n  .select-month{\r\n    width: 9rem;\r\n    float: left;\r\n    margin-right: 1rem;\r\n  }\r\n  .select-year{\r\n    width: 7.5rem;\r\n  }\r\n  @media only screen and (max-width:768px){\r\n    .select-day{\r\n      width: 5.5rem;\r\n      float: left;\r\n      margin-right: 1rem;\r\n    }\r\n  \r\n    .select-month{\r\n      width: 5.5rem;\r\n      float: left;\r\n      margin-right: 1rem;\r\n    }\r\n  \r\n    .select-year{\r\n      width: 5.5rem;\r\n    }\r\n    \r\n\r\n  }\r\n  .codeSend{\r\n    display: -webkit-inline-box;\r\n    display: -ms-inline-flexbox;\r\n    display: inline-flex;\r\n    margin: auto;\r\n  }\r\n  @media only screen and (max-width:1080px){\r\n    .btn-lg{\r\n      padding: 0.5rem !important;\r\n    }\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/auth/save-username/save-username.component.css
// module id = ../../../../../src/app/auth/save-username/save-username.component.css
// module chunks = main